import { render, staticRenderFns } from "./NewspaperDetails.vue?vue&type=template&id=228e3c3e"
import script from "./NewspaperDetails.vue?vue&type=script&lang=js"
export * from "./NewspaperDetails.vue?vue&type=script&lang=js"
import style0 from "./NewspaperDetails.vue?vue&type=style&index=0&id=228e3c3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports